
<script>
import { Link } from "@inertiajs/inertia-vue3";
export default {
    components: { Link },    
    props: {
        links: Array,
    }, 
};
</script>

<template>
<div class="mt-3">
    <nav v-if="links.length > 3">
        <ul class="pagination justify-content-center">
            <li v-for="(link, k) in links" :key="k" class="page-item" :class="{'active': link.active }">
                <Component
                    :is="link.url ? 'Link' : 'span'"
                    class="page-link"
                    :href="link.url"
                    v-html="k ? (k == 14 ? `<i class='bi bi-chevron-right'></i>` : link.label) : `<i class='bi bi-chevron-left'></i>`"
                />
            </li>
        </ul>
    </nav>

</div>
</template> 